import { render, staticRenderFns } from "./CalendarInfo.vue?vue&type=template&id=36f3ce8f&"
import script from "./CalendarInfo.vue?vue&type=script&lang=js&"
export * from "./CalendarInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports